namespace('arctic.views.groupLanding');

arctic.views.groupLanding.groupMemberSummary = function(viewport) {

	/*
	 * properties.
	 */
	var _viewport = viewport;
	var d = jQuery.dom;
	var $j = jQuery;
	
	var _divs = {};
	var _pageJSON = {};
	var me = this;

	/*
	 * self executing constructor.
	 */
	/*
	 * create the dom nodes of this view.
	 */
	var _render = function(d) {
		_divs.groupLandingSummary = d.div({ id : "groupMemberSummary" },
			d.div(
				d.p({className:'thanks'},'Thanks for booking!!'),
					d.div({className:'resInfoDiv'},
						d.p('You are confirmed at:'),
						d.div({className:'resDetailsDiv'},
							d.p(_pageJSON.resInfo.hotelName),
							d.p(_pageJSON.resInfo.roomType),
							d.p(_pageJSON.resInfo.arrive + ' - ' + _pageJSON.resInfo.depart)
					)
				)
			),
		  d.div({className:'contactDiv'}, 
		  	d.p({className : "questions"},'Questions?'), 
		  	d.p('Contact your group manager:'),
		  	d.div({className:'contactDemoInfo'},
		  		d.p({className : "groupManagerContact groupManagerName"},_pageJSON.groupContact.contactName),
		  		d.p({className : "groupManagerContact"},_pageJSON.groupContact.contactEmail),
		  		d.p({className : "groupManagerContact"},_pageJSON.groupContact.contactNumber)
		  	)
		  ),d.div({className:'endView'})
		 );

		_viewport.append(_divs.groupLandingSummary);

	};
	/*
	 * create the variuos widget objects and render their doms.
	 */
	var _setupWidgets = function(viewdata) {
		
	};
	/*
	 * setup all the controls.
	 */
	var _setupControls = function() {
				
	};/* end of setup controls. */

	this.run = function(renderComplete) {
		compass.loading.start();
		jQuery.ajax({
			url : '/groupMemberSummaryInfo',
			success : function(data) {
				compass.loading.stop();
				_pageJSON = data;
				_render(jQuery.dom);
				// move this into a renderer for testing.
				_setupWidgets(data);
				// draws the widgets and passes any rendering data into them.
				_setupControls();
				// sets up controls on the widgets. setups controls on the view itself.
				renderComplete();
			}
		});
	};
};

